<template>
<div :class="primitiveBaseClasses">
    <label class="amf-input-label" v-if="$_showLabel">{{label}}</label>
    <datepicker v-model.lazy="internalValue"
        :placeholder="caption"
        :input-class="['form-control']"
        :class="[{ invalid: hasError }]"
        :disabled="$_disabled"
        :disabledDates="datesDisabled"
        :highlighted="datesHighlighted"
        :open-date="openDate"
        :calendar-button="calendarButton"
        :calendar-class="calendarClass"
        bootstrap-styling
        format="MM/dd/yyyy"
        :typeable="typeable"
        calendar-button-icon="fa fa-calendar"
        @input="dateChanged">
    </datepicker>
    <div class="error-div">
        {{validationMessage}}
    </div>
</div>
</template>

<script>
import Datepicker from 'vuejs-datepicker'
import primitiveMixin from './primitive-mixin'

export default {
    mixins: [primitiveMixin],
    components: {
        Datepicker
    },
    props: {
        value: {
            type: [Date, String, Number],
            default: null,
        },
        label: {
            type: String,
            default: null,
            required: false
        },
        max: {
            type: [Date, String],
            default: null,
            required: false
        },
        min: {
            type: [Date, String],
            default: null,
            required: false
        },
        openDate: {
            type: [Date, String],
            default: null,
            required: false
        },
        highlightedDates: {
            type: Array,
            default: () => [],
            required: false,
        },
        disabledDates: {
            type: Array,
            default: () => [],
            required: false,
        },
        hideCalendar: {
            type: Boolean,
            default: false
        },
        typeable: {
            type: Boolean,
            default: true
        }
    },
    data() {
        return {
            internalValue: this.value,
            calendarButton: true,
            calendarClass: null,
            caption: null
        }
    },
    created() {
        if (this.internalValue && !_.isDate(this.internalValue)){
            this.internalValue = moment(this.internalValue).startOf("day").toDate();
        }

        if (this.hideCalendar) {
            this.calendarButton = false;
            this.calendarClass = "hide-calendar";
            this.caption = "__/__/____";
        }
    },
    computed: {
        datesDisabled() {
            return {
                to: this.min ? moment(this.min).toDate() : null,
                from: this.max ? moment(this.max).toDate() : null,
                dates: this.disabledDates || null,
            };
        },
        datesHighlighted() {
          return {
            dates: this.highlightedDates || [],
            includeDisabled: true,
          };
        },
    },
    methods: {
        dateChanged(date) {
            this.internalValue = date ? moment(date).startOf('day').toDate() : null;
        }
    },
    watch: {
        value(newValue) {
            this.internalValue = newValue;
        },
        internalValue: {
            handler: function(val, oldVal){
                if((!val && oldVal) || (val && !oldVal)) {
                    this.changeMade({ name: this.label, value: val});
                }
                if(val && oldVal) {
                    let same = moment(oldVal).startOf('day').isSame(moment(val).startOf('day'));
                    if(!same) this.changeMade({ name: this.label, value: val});
                }
                this.$emit("input", val);
            }
        },
    }
}
</script>

<style lang="scss">
.vdp-datepicker.invalid .input-group {
    input {
        border: red solid 2px;
        border-left: 0;
    }
    .input-group-text {
        border: red solid 2px;
        border-right: 0;
    }
}

.hide-calendar {
    display: none !important;
}
// .vdp-datepicker__calendar {
//     position: fixed !important;
// }
</style>



// WEBPACK FOOTER //
// src/framework/primitives/AmfDatepicker.vue